const {
  MQ_SOCKET_URL,
  OSS_URL,
  VITE_OSS_ACCESS_KEY,
  RECAPTCHA_KEY,
  MQ_API_URL,
  MQ_HAS_NOTICE,
  MQ_NOTICE_CONTENT,
  MQ_EDGE_API,
  MQ_LIVECHAT_APP_URL,
  MQ_MPUSH_ROBOT_APP_URL,
  runEnv,
  runVersion,

  MQ_CUSTOMER_APP_URL,
  MQ_MICROS_ENTRY_APP_URL,
  JAVA_API_URL,
  MQ_ORG_ID,
  MQ_LIMIT_REGISTER
} = window;

export default {
  MQ_SOCKET_URL,
  OSS_URL,
  VITE_OSS_ACCESS_KEY,
  RECAPTCHA_KEY,
  MQ_API_URL,
  MQ_HAS_NOTICE,
  MQ_NOTICE_CONTENT,
  MQ_EDGE_API,
  MQ_LIVECHAT_APP_URL,
  MQ_MPUSH_ROBOT_APP_URL,
  runEnv,
  runVersion,
  MQ_CUSTOMER_APP_URL,
  MQ_MICROS_ENTRY_APP_URL,
  JAVA_API_URL,
  MQ_ORG_ID,
  MQ_LIMIT_REGISTER
};
